import React from "react"
import {AsyncResultModal} from "../../AsyncResultModal/AsyncResultModal"
import {AsyncResultIdleRequestState} from "../../../types/asyncResultIdle"
import {ErrorDocument} from "../../../resources/common"
import {refreshAndClose} from "../../../utilities/modals"

interface ResetToDefaultRiskSettingsConfirmationModalProps {
	state: AsyncResultIdleRequestState<any, ErrorDocument>
	onSubmit: () => Promise<void>
	close: () => void
	refresh: () => void
	orgName: string
}

export default function ResetToDefaultRiskSettingsConfirmationModal({
	state,
	onSubmit,
	close,
	refresh,
	orgName,
}: ResetToDefaultRiskSettingsConfirmationModalProps) {
	return (
		<AsyncResultModal
			title={`Reset to the bank's default onboarding rules?`}
			buttonText="Yes, Reset to default"
			buttonClassname="is-danger is-outlined"
			cancelButtonText="Cancel"
			cancelButtonClassname="button is-white"
			state={state}
			onSubmit={onSubmit}
			successText="Reset Succesfully"
			errorToText={(err) => err.errors?.[0].title ?? "An error has occurred"}
			close={close}
			onSuccess={refreshAndClose(refresh, close)}
			onSuccessDelay={1500}
			disableCloseOnSuccess
		>
			{`By resetting to default, any of ${orgName}'s current exceptions to default rules will be lost.`}
		</AsyncResultModal>
	)
}
